import { Action, createAction } from '@reduxjs/toolkit';
import { PermissionsState } from './store';
import { Effect } from 'typed-redux-saga/macro';

export interface TryPermissionPayload {
  permissionKey: keyof PermissionsState;
  onAllow?: () => Generator<Effect | Action, void, unknown>;
  onBlock?: () => Generator<Effect | Action, void, unknown>;
}

export const SET_PERMISSIONS = createAction<SetPermissionsPayload>(
  'vtn-app-user-permissions/SET_PERMISSIONS'
);
// TODO: Can we do better than any here?
export const TRY_PERMISSION = createAction<TryPermissionPayload>(
  'vtn-app-user-permissions/TRY_PERMISSION'
);

export type SetPermissionsPayload = Partial<PermissionsState>;

export const actionSetUserPermissions = (payload: SetPermissionsPayload) =>
  SET_PERMISSIONS(payload);

export const actionTryPermission = (payload: TryPermissionPayload) =>
  TRY_PERMISSION(payload);
